import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-deliverable-win',
  templateUrl: './deliverable-win.component.html',
  styleUrls: ['./deliverable-win.component.scss']
})
export class DeliverableWinComponent implements OnInit, AfterViewInit {

  @ViewChild('winPopupWithReceipt', { static: false }) winPopupWithReceiptRef: any;
  @ViewChild('captureSuccessWithReceipt', { static: false }) captureSuccessWithReceiptRef: any;


  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  winDetails: any;
  userId: any;
  clicked = false;
  showSurvey = true;
  isPhoneParticipation = false;

  captureAddress = {
    Name: '',
    Email: '',
    Phone: '',
    Address: '',
    PostalCode: '',
    City: ''
  };

  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     public translate: TranslateService,
     private router: Router,
     private authService: AuthService,
     private coreService: CoreService,
     private gaService: GaService,
     ) {
      this.winDetails = this.dataService.getWinDetails()
      this.userId = this.authService.getUserId();
  }

  ngOnInit() {
    if(this.authService.IsLoggedIn()){
      this.isPhoneParticipation = false;
      this.captureAddress.Email = localStorage.getItem('email');
      // this.captureAddress.Phone = (parseInt(localStorage.getItem('user'))/111).toString();
      // if(this.captureAddress.Phone){
      //   this.isPhoneParticipation = true;
      // } else {
      //   this.isPhoneParticipation = false;
      // }
    }
    if(localStorage.getItem('surveyTaken') == 'true') {
      this.showSurvey = false;
    }
  }


  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.winPopupWithReceiptRef, this.popupConfig);

  }


  onSubmitWinWithReceipt(f:any) {
    this.clicked = true;
    if (this.winDetails.isRewardDeliverable) {
      const body = {
        FirstName: this.captureAddress.Name,
        Address: this.captureAddress.Address,
        PostalCode: this.captureAddress.PostalCode,
        City: this.captureAddress.City,
        Phone: this.captureAddress.Phone,
        Email: this.captureAddress.Email,
        RewardPartitionKey: this.winDetails ? this.winDetails.rewardPK : undefined,
        UserId: this.userId,
        UserRewardRowKey: this.winDetails ? this.winDetails.userRewardRK : undefined
      };
      this.coreService.captureAddress(body).then(response => {
        this.gaService.emitEvent('reward_redeemed', 'reward_redeemed');

        f.submitted = false;
        this.modalRef.hide();
        this.resetWinDetails();
        this.modalRef = this.modalService.show(this.captureSuccessWithReceiptRef, this.popupConfig);
      });
    }
  }
  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // playAgain() {
  //   this.getPlay();
  // }

  redirectToHome() {
    this.modalRef.hide();
    this.router.navigate([''])
  }

  resetWinDetails() {
    this.captureAddress = {
      Name: '',
      Email: '',
      Phone: '',
      Address: '',
      PostalCode: '',
      City: ''
    };
  }
  surveyTaken() {
    localStorage.setItem('surveyTaken','true')
  }

}
